<template>
  <v-container fluid>
    <v-layout row wrap align-center>
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 lg4 offset-lg4 text-center>
        <img :src="protocol.logo" class="mb-5 mt-5 logo" />
        <v-card color="secondary" class="white--text mb-3 mt-5 welcome-card">
          <v-card-title primary-title>
            <div style="width:100%;">
              <div
                class="headline mb-3"
              >{{protocol.version.protocol_definition.public_welcome_message}}</div>
              <span v-if="this.protocol.saved_values.address">
                {{this.protocol.saved_values.address.street}} {{this.protocol.saved_values.address.apartmentNr}}
                <br />
                {{this.protocol.saved_values.address.zip}} {{this.protocol.saved_values.address.city}}
              </span>
              <div class="mt-2" v-if="this.protocol.saved_values.caseNr">
                Saksnummer: {{ this.protocol.saved_values.caseNr }}
              </div>
              <div v-if="this.protocol.saved_values.assignmentNr">
                Oppdragsnummer: {{ this.protocol.saved_values.assignmentNr }}
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 lg4 offset-lg4 text-center v-if="stepValues.reason">
        <v-select
          :items="items"
          box
          label="Årsak til at leiekontrakten opphører"
          v-model="stepValues.reason"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 text-center>
        <v-btn large color="primary" @click="next">Start nå</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import step from "../mixins/step"
export default {
  mixins: [step],
  data() {
    return {
      items: ['Utløp på tid', 'Oppsigelse', 'Fravikelse manglende betaling', 'Heving', 'Bytte av hovedleietaker i bofellesskap']
    };
  },
  beforeMount: function() {
    if (!this.protocol.saved_values.address) {
      this.protocol.saved_values.address = {
        street: null,
        zip: null,
        city: null,
        apartmentNr: null
      };
    }
  }
};
</script>


<style>
.logo {
  max-width: 300px;
}
</style>